import { useViewData } from "../view-data";
import { useUpdateOptionPmsColorItem } from "./use-update-option-pms-color-item";

import type * as Repository from "../../../_repository";

type Props = {
	hotelID: string;
	optionPmsColorListQueryData: Repository.Query.QueryData.OptionPmsColorListQueryData;
};

export const useInitialized = ({ hotelID, optionPmsColorListQueryData }: Props) => {
	/**
	 * ViewData の生成
	 */
	const { viewData } = useViewData({ optionPmsColorListQueryData });

	const {
		// カラーの更新
		onUpdateOptionPmsColorItem,
	} = useUpdateOptionPmsColorItem({ hotelID });

	return {
		// readonly
		viewData,
		// mutable
		// カラーの更新
		onUpdateOptionPmsColorItem,
	};
};
